
    <ng-container
      *ngIf="useText$ | async; else relate;"
      [ngTemplateOutlet]="text"
    >
    </ng-container>

    <ng-template #relate>
      <ng-select
        [(ngModel)]="relateValue"
        [items]="options$ | async"
        appendTo="body"
        bindLabel="text"
        class="fieldmagic-data-grid-relate-dropdown"
        [clearable]="clearable$ | async"
        [multiple]="multi$ | async"
        [placeholder]="placeholder$ | async | translate"
        [typeahead]="typeahead$"
        [matTooltip]="tooltip$ | async"
        (ngModelChange)="onChanged()"
        (open)="onOpen()"
      >
        <!-- displayed for the selected dropdown option -->
        <ng-template
          ng-label-tmp
          let-item="item"
          let-clear="clear"
        >
          <span class="ng-value-label">{{ item.text | translate }}</span>
          <span
            *ngIf="multi$ | async"
            class="ng-value-icon right selected-close"
            (click)="clear(item)"
            innerText="x"
          >
          </span>
        </ng-template>

        <!-- displayed for the dropdown options -->
        <ng-template
          ng-option-tmp
          let-item="item"
        >
          <span class="ng-value-label">{{ item.text | translate }}</span>
        </ng-template>
      </ng-select>
    </ng-template>

    <ng-template #text>
      <div class="w-100 h-100 d-flex p-2 flex-column">
        <textarea
          rows="10"
          cols="60"
          class="form-control font-size-11 fieldmagic-data-grid-textarea-input"
          [(ngModel)]="textValue"
          [attr.maxLength]="max"
          [matTooltip]="tooltip$ | async"
          [attr.placeholder]="placeholder$ | async"
          (ngModelChange)="onChanged()"
          (keydown)="onKeyDown($event)"
          autofocus
        >
        </textarea>

        <div
          *ngIf="max | filled"
          class="d-flex w-100 justify-content-end"
        >
          <small class="text-help">
            {{ '%d/%d' | sprintf: [remaining$ | async, max]}}
          </small>
        </div>
      </div>
    </ng-template>
  